import Box from '@mui/material/Box';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-icon.svg';
import { closeDialog } from '../../../store/dialog/dialog.action';

const DialogTitle = ({
    title,
    moreActions,
    icon,
}: {
    title: string;
    moreActions?: ReactNode;
    icon?: ReactNode;
}) => {
    const dispatch = useDispatch();

    const handleCloseButtonClick = () => {
        dispatch(closeDialog());
    };

    return (
        <MuiDialogTitle display={'flex'} justifyContent={'space-between'}>
            <Box display="flex" alignItems="center" gap={2}>
                {icon && (
                    <Box display="flex" alignItems="center">
                        {icon}
                    </Box>
                )}
                {title}
            </Box>
            <Box>
                {moreActions}
                <IconButton
                    aria-label="close"
                    onClick={handleCloseButtonClick}
                    size={'small'}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </MuiDialogTitle>
    );
};

export default DialogTitle;
